<template>
    <div>
        <!-- 人员点位图层 -->
        <LVector :zIndex="30" v-if="config.layerAuto.hasEmergencyPersonnel" :selectFeature="selectUser">
            <template v-for="(item, index) in userList">
                <LPointFeature v-if="item.longitude" :key="item.id + '_name'" :id="item.id + '_name'"
                    :defaultStyle="personnelStyle(item)" :latitude="+item.latitude" :longitude="+item.longitude"
                    :obj="item" :overlayOffset="[0, -56]" className="command-overlayer-personnel-top">
                    <div slot="labelOverlay" class="point-top personnel" v-if="item.longitude" v-show="mapZoom >= 13.3">
                        {{ item.name || item.userName }} - {{ item.teamName }}
                    </div>
                </LPointFeature>
            </template>
        </LVector>

        <!-- 人员连线 -->
        <LVector :zIndex="30" v-if="config.dangerObj">
            <template v-for="(item, index) in userList">
                <LLineFeature v-if="item.point && item.point.length" :key="item.id + '_line'" :id="item.id + '_line'"
                    :pointData="item.point" :defaultStyle="{
                        stroke: {
                            color: '#49f0fd',
                            width: 2,
                            lineDash: [5, 5],
                        },
                    }" />
            </template>
        </LVector>

        <!-- 人员距离文本标注 -->
        <LVector :zIndex="31" v-if="config.dangerObj">
            <template v-for="(item, index) in userList">
                <LPointFeature v-if="item.longitude && item.hasCheckedBox" :longitude="item.km_longitude"
                    :latitude="item.km_latitude" :key="item.id + '_km'" :id="item.id + '_km'" :obj="item"
                    :overlayOffset="[0, 0]" className="command-overlayer-user-km">
                    <div v-if="config.defaultCheckList.some((i) => i.id === item.id)" slot="labelOverlay"
                        class="point-distance-active" v-show="item.hasCheckedBox">
                        {{
                            {
                                ponit1: { latitude: +item.latitude, longitude: +item.longitude },
                                point2: {
                                    latitude: +config.dangerCoordinate.latitude,
                                    longitude: +config.dangerCoordinate.longitude,
                                },
                            } | getDistance
                        }}推荐
                    </div>
                    <div v-else slot="labelOverlay" class="point-distance" v-show="item.hasCheckedBox">
                        {{
                            {
                                ponit1: { latitude: +item.latitude, longitude: +item.longitude },
                                point2: {
                                    latitude: +config.dangerCoordinate.latitude,
                                    longitude: +config.dangerCoordinate.longitude,
                                },
                            } | getDistance
                        }}
                    </div>
                </LPointFeature>

            </template>
        </LVector>

        <!-- 右侧人员列表 -->
        <div class="personnel-list" v-show="config.dangerObj">
            <div class="list-title">人员列表</div>
            <div class="list-content">
                <template v-if="userList.length > 0">
                    <template v-for="item in userCheckList">
                        <div v-if="item.latitude && item.longitude" :key="item.id + '_personnel'" class="personnel-item"
                            :class="{ active: item.checked }">
                            <!--  :disabled="!item.teamId || !(config.dangerObj && config.dangerObj.status === 0)" -->
                            <el-checkbox v-model="item.checked" @change="handleUserCheck(item)"
                                class="personnel-checkbox">
                                <div class="item-info" @click.stop>
                                    <div class="name">{{ item.name || item.personnelName }}</div>
                                    <div class="distance">距离：{{ item.distance || '--' }}</div>
                                    <div class="duration">预计时间：{{ item.duration || '--' }}</div>
                                </div>
                            </el-checkbox>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div class="no-data">暂无数据</div>
                </template>

            </div>
        </div>
        <el-popover placement="right" trigger="click" @hide="showPointLeaderTip = false" v-model="showPointLeaderTip"
            popper-class="emergency-tooltip">
            <PointLeaderInfoTooltip ref="personne" v-if="showPointLeaderTip" :selectUserObj="selectUserObj"
                :showPointLeaderTipFn="showPointLeaderTipFn" :dangerObj="config.dangerObj"
                @closePointLeaderTipFn="showPointLeaderTip = false"></PointLeaderInfoTooltip>
            <div slot="reference" :style="style"></div>
        </el-popover>
    </div>
</template>

<script>
import { tool } from '@CesiumCommon';
import { LVector, LPointFeature, LLineFeature, OMapMixin } from '@OpenLayersCommon';
import { getDistance } from '@/page/business/util/index.js';
import PointLeaderInfoTooltip from './ol-point/point-leader-info-tooltip.vue';
import api from '../api/index.js';

export default {
    mixins: [OMapMixin],
    props: {
        userList: {
            type: Array,
            default: () => [],
        },
        config: {
            type: Object,
            default: () => ({
                dangerObj: null,
                dangerCoordinate: {},
                layerAuto: {},
                statiMapHives: [],
                selectDistance: '3km内',
                defaultCheckList: [],
                changeUserList: () => { },
                changeStatiMapHives: () => { },
                initUserList: () => { },
            }),
        },
    },
    emits: [
        'update:showCloseBtn',
        'update:userCheckList',
    ],
    components: {
        LVector,
        LPointFeature,
        LLineFeature,
        PointLeaderInfoTooltip,
    },
    data () {
        return {
            mapZoom: 14.5,
            userCheckList: [],
            showPointLeaderTip: false,
            selectUserObj: null,
            style: {
                position: 'absolute',
                top: '100px',
                left: '200px',
            },
        };
    },
    async mounted () {
        let map = await this.getMap();
        this.map = map;
        this.changeZoom();
        this.map.getView().on('change:resolution', this.changeZoom);
        // 初始化勾选列表
        this.syncUserCheckList();
    },
    beforeDestroy () {
        this.map && this.map.getView().un('change:resolution', this.changeZoom);
    },
    filters: {
        getDistance (points) {
            let { ponit1, point2 } = points;
            let distance = +tool.distance(ponit1, point2);
            if (distance / 1000 >= 1) {
                distance = `${(distance / 1000).toFixed(1)}km`;
            } else {
                distance = `${distance}m`;
            }
            return distance;
        },
    },
    watch: {
        userList: {
            deep: true,
            handler () {
                this.syncUserCheckList();
            },
        },
        'config.selectDistance': {
            handler (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.setDefaultCheckList();
                }
            },
        },
    },
    methods: {
        // 同步userCheckList与userList（保持勾选状态同步）
        syncUserCheckList () {
            // 增量同步：复用已有勾选状态，id唯一，直接匹配id
            this.userCheckList = this.userList.map((item) => {
                const existing = this.userCheckList.find((u) =>
                    u.id && item.id && u.id === item.id,
                );
                return {
                    ...item,
                    checked: existing ? existing.checked : false,
                };
            });
            this.$emit('update:userCheckList', [...this.userCheckList]);
        },

        // 人员复选框勾选状态变更
        handleUserCheck (item) {
            // item已经在userCheckList中（v-for遍历的就是userCheckList）
            // 直接更新hasCheckedBox并确保响应式
            this.$set(item, 'hasCheckedBox', item.checked);
            // 如果勾选且还没有计算过距离，则计算距离和预计时间
            if (item.checked && !item.distance) {
                this.calcdistanceAndTime(item);
            }
            // 同步更新到userList中保持一致性，id唯一，找到匹配的更新
            const targetInList = this.userList.find((u) =>
                u.id && item.id && u.id === item.id,
            );
            if (targetInList) {
                this.$set(targetInList, 'checked', item.checked);
                this.$set(targetInList, 'hasCheckedBox', item.checked);
            }
            // 通知父组件 - 使用新数组触发响应式更新
            this.$emit('update:userCheckList', [...this.userCheckList]);
        },
        /**
         * 处理用户选中事件，显示用户信息并计算与事发点的距离和时间
         *
         * @param {Object} e - 鼠标事件对象，包含pixel_属性（像素坐标）
         * @param {string|number} id - 选中要素的标识符
         * @param {Object} feature - 选中要素的地理信息
         * @param {Object} obj - 用户数据对象，包含用户信息及关联的caseId
         */
        async selectUser (e, id, feature, obj) {
            let [x, y] = e.pixel_;
            this.style.top = `${y}px`;
            this.style.left = `${x}px`;

            // console.log('selectUser', obj);
            // 获取班组详情
            this.getTeamDetail(obj.teamId);

            // this.selectUserObj = [obj];
            // console.log('this.dangerObj', this.dangerObj);
            // this.selectUserObj.forEach(async (item) => {
            //     // 计算距离事发点时间和距离
            //     if (item.caseId) {
            //         let caseInfo = this.caseListAll.find((caseItem) => caseItem.id === item.caseId);
            //         await this.calcdistanceAndTime(item,  this.dangerObj);
            //     }
            // });
            setTimeout(() => {
                this.showPointLeaderTip = true;
            }, 50);
        },
        /**
         * 获取应急班组详情。
         * @param {id:班组id} params
         * @returns
         */
        async getTeamDetail (id) {
            let res = await api.getTeamDetail(id);
            console.log('getTeamDetail', res);
            this.selectUserObj = res.data; // return res.data;
        },

        showPointLeaderTipFn (val) {
            this.showPointLeaderTip = val;
        },

        // 设置默认勾选（距离事发点指定范围内的人员）
        async setDefaultCheckList () {
            const distanceLimit = parseInt(this.config.selectDistance, 10);
            // 第一步：先标记哪些需要勾选，并收集需要计算distance的promise
            const calcPromises = [];
            const dangerLat = this.config.dangerCoordinate?.latitude;
            const dangerLng = this.config.dangerCoordinate?.longitude;

            // 如果危险坐标无效，跳过计算
            if (dangerLat === undefined || dangerLng === undefined || dangerLat === '' || dangerLng === '') {
                return;
            }

            this.userCheckList.forEach((user) => {
                let inRange = false;
                if (user.distance) {
                    let distance = parseFloat(user.distance);
                    const isKm = user.distance.includes('km');
                    const realDistance = isKm ? distance : distance / 1000;
                    inRange = realDistance <= distanceLimit;
                } else if (user.latitude && user.longitude) {
                    // 没有计算过distance，先判断直线距离是否在范围内
                    const straightDistance = tool.distance(
                        { latitude: +user.latitude, longitude: +user.longitude },
                        { latitude: +dangerLat, longitude: +dangerLng },
                    );
                    const realDistance = straightDistance / 1000;
                    inRange = realDistance <= distanceLimit;
                }
                this.$set(user, 'checked', inRange);
                this.$set(user, 'hasCheckedBox', inRange);
                // 如果勾选且还没有计算过距离，则计算距离和预计时间
                if (inRange && !user.distance) {
                    calcPromises.push(this.calcdistanceAndTime(user));
                }
            });

            // 第二步：等待所有计算完成
            await Promise.all(calcPromises);

            // 第三步：收集默认勾选的人员到defaultCheckList，用于距离文本标记
            // 只保留已经计算出distance的人员参与排序，选择最近的一个
            let candidates = this.userCheckList
                .filter((user) => user.checked && user.distance && user.distance !== '--');
            candidates.forEach((item) => {
                if (item.distance.includes('km')) {
                    item.sortKm = Number(item.distance.split('km')[0]);
                } else if (!item.distance.includes('km')) {
                    item.sortKm = Number(item.distance.split('m')[0]) / 1000;
                }
            });
            // 如果有已经计算好的，选最近的一个；否则从已勾选中选第一个
            let defaultCheckList = [];
            if (candidates.length > 0) {
                candidates.sort((a, b) => a.sortKm - b.sortKm);
                defaultCheckList = candidates.slice(0, 1);
            } else {
                const firstChecked = this.userCheckList.find((user) => user.checked);
                defaultCheckList = firstChecked ? [firstChecked] : [];
            }

            if (typeof this.config.changeStatiMapHives === 'function') {
                this.config.changeStatiMapHives(true, null, true, defaultCheckList);
            }

            this.$emit('update:userCheckList', [...this.userCheckList]);
        },

        // 获取高德驾车路线
        getPolyline (origin, destination) {
            // 转成高德gcj02坐标去查
            const originLng = Number(origin[0]);
            const originLat = Number(origin[1]);
            const destLng = Number(destination[0]);
            const destLat = Number(destination[1]);

            // 验证坐标有效性
            if (isNaN(originLng) || isNaN(originLat) || isNaN(destLng) || isNaN(destLat)) {
                return Promise.reject(new Error('Invalid coordinates'));
            }

            let origins = tool.transform.wgs84togcj02(originLng, originLat);
            let destinations = tool.transform.wgs84togcj02(destLng, destLat);

            let userOrigin = `${origins[0].toFixed(6)},${origins[1].toFixed(6)}`;
            let dangerCoordinate = `${destinations[0].toFixed(6)},${destinations[1].toFixed(6)}`;

            // 从localStorage获取系统配置的高德key
            let shUser = localStorage.getItem('sh_user');
            let userInfo = JSON.parse(shUser || '{}');
            // userInfo.tenantExtInfo?.amapDevKey ||
            let amapDevKey = 'eb4d15b428372525557ad06110e3afdb';

            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open(
                    'get',
                    `https://restapi.amap.com/v3/direction/driving?origin=${userOrigin}&destination=${dangerCoordinate}&strategy=10&key=${amapDevKey}`,
                );
                xhr.send();
                xhr.onload = resolve;
                xhr.onerror = reject;
            });
        },

        // 计算人员距离和预计时间
        async calcdistanceAndTime (item) {
            try {
                const { longitude: lng1, latitude: lat1 } = this.config.dangerCoordinate;
                const { longitude: lng2, latitude: lat2 } = item;

                if (lng1 === undefined || lat1 === undefined || lng2 === undefined || lat2 === undefined) {
                    this.setEmptyResult(item, lat2 || item.latitude, lng2 || item.longitude);
                    return;
                }

                if (!lng1 || !lat1 || !lng2 || !lat2) {
                    this.setEmptyResult(item, lat2 || item.latitude, lng2 || item.longitude);
                    return;
                }

                const point1 = [lng1, lat1];
                const point2 = [lng2, lat2];
                let distance = 0;
                let duration = 0;
                let arr = [[lng1, lat1], [lng2, lat2]];
                let kmLat = (lat1 + lat2) / 2;
                let kmLng = (lng1 + lng2) / 2;

                const response = await this.getPolyline(point2, point1);
                const data = JSON.parse(response.target.response);

                if (this.isValidAmapResponse(data)) {
                    const path = data.route.paths[0];
                    distance = Number(path.distance);
                    duration = Number(path.duration);
                    arr = this.parseAmapPolyline(path);
                    this.updateMidPoint(arr, kmLat, kmLng, (newLat, newLng) => {
                        kmLat = newLat;
                        kmLng = newLng;
                    });
                } else {
                    const straightLineRes = await getDistance(lat1, lng1, lat2, lng2);
                    distance = straightLineRes.distance || 0;
                    duration = straightLineRes.duration || 0;
                }

                this.validateMidPoint(kmLat, kmLng, lat1, lat2, lng1, lng2, (newLat, newLng) => {
                    kmLat = newLat;
                    kmLng = newLng;
                });

                this.$set(item, 'point', arr);
                this.$set(item, 'distance', this.formatDistance(distance));
                this.$set(item, 'duration', this.convertSecondsToTime(duration));
                this.$set(item, 'km_latitude', kmLat);
                this.$set(item, 'km_longitude', kmLng);
            } catch (error) {
                console.error('计算人员距离失败：', error);
                this.setEmptyResult(item, item.latitude, item.longitude);
            }
        },

        // 设置空结果
        setEmptyResult (item, lat, lng) {
            this.$set(item, 'distance', '--');
            this.$set(item, 'duration', '--');
            this.$set(item, 'km_latitude', lat);
            this.$set(item, 'km_longitude', lng);
        },

        // 检查高德API响应是否有效
        isValidAmapResponse (data) {
            return data.status === '1' && data.route && data.route.paths && data.route.paths[0];
        },

        // 解析高德折线坐标
        parseAmapPolyline (path) {
            return path.steps
                .map((step) => step.polyline)
                .map((polyline) => polyline.split(';'))
                .flat(Infinity)
                .map((coords) => coords.split(',').map(Number))
                .map(([lng, lat]) => tool.transform.gcj02towgs84(lng, lat))
                .filter(([lng, lat]) => !isNaN(lng) && !isNaN(lat));
        },

        // 更新中点坐标
        updateMidPoint (arr, kmLat, kmLng, callback) {
            if (arr.length === 0) return;
            const midIndex = Math.round(arr.length / 2);
            const [midLng, midLat] = arr[midIndex];
            if (!isNaN(midLat) && !isNaN(midLng)) {
                callback(midLat, midLng);
            }
        },

        // 验证中点坐标，无效则使用直线中点
        validateMidPoint (kmLat, kmLng, lat1, lat2, lng1, lng2, callback) {
            if (isNaN(kmLat)) callback((lat1 + lat2) / 2, kmLng);
            if (isNaN(kmLng)) callback(kmLat, (lng1 + lng2) / 2);
        },

        // 格式化距离显示
        formatDistance (distance) {
            if (!distance || distance <= 0) return '--';
            return distance >= 1000
                ? `${(distance / 1000).toFixed(1)}km`
                : `${Math.round(distance)}m`;
        },

        // 格式化预计时间
        convertSecondsToTime (seconds) {
            if (!seconds) return '--';
            const minutes = Math.round(seconds / 60);
            if (minutes < 60) {
                return `${minutes}分钟`;
            } else {
                const hours = Math.floor(minutes / 60);
                const mins = minutes % 60;
                if (mins === 0) {
                    return `${hours}小时`;
                }
                return `${hours}小时${mins}分钟`;
            }
        },

        // 人员点位样式
        personnelStyle (item) {
            let mapZoom = this.mapZoom;
            let scale = (mapZoom - 13) * 0.2 + 0.6;
            if (scale < 0.6) scale = 0.6;
            if (scale > 1) scale = 1;

            return {
                icon: {
                    src: this.userIcon(item),
                    scale,
                    offset: [-20, 0],
                    size: [100, 100],
                },
                text: {
                    textAlign: 'center',
                    textBaseline: 'middle',
                    font: 'normal 14px Microsoft YaHei-Regular, Microsoft YaHei',
                    text: this.mapZoom > 13.3 ? item.address : '',
                    offsetY: 40 * scale,
                    offsetX: 0,
                    fill: {
                        color: '#FFFFFF',
                    },
                    stroke: {
                        color: '#000',
                        width: 1,
                    },
                    padding: [2, 5, 2, 5],
                },
            };
        },
        userIcon (item) {
            let src;
            switch (true) {
                case item.statusLabel === '待命':
                    src = require('./images/user-icon-1.png');
                    break;
                case item.statusLabel === '工作中':
                    src = require('./images/user-icon-2.png');
                    break;
                case item.statusLabel === '请假':
                    src = require('./images/user-icon-3.png');
                    break;

                default:
                    src = require('./images/user-icon-3.png');
                    break;
            }
            return src;
        },

        // 监听地图缩放
        changeZoom () {
            const zoom = this.map.getView().getZoom();
            this.mapZoom = zoom;
        },
    },
};
</script>

<style lang="scss" scoped>
.command-overlayer-personnel-top {
    z-index: 20;
}

.point-top.personnel {
    background: rgba(2, 102, 204, 0.6);
    border: 1px solid #49f0fd;
    box-shadow: inset 0px 1px 9px 0px rgba(73, 240, 253, 0.4);
    padding: 5px 10px;
}

// 人员列表样式
.personnel-list {
    position: absolute;
    top: 65px;
    right: 120px;
    width: 200px;
    background: rgba(7, 17, 80, 0.8);
    border: 1px solid #49f0fd;
    border-radius: 4px;
    color: #fff;

    .list-title {
        padding: 8px 10px;
        background: rgba(73, 240, 253, 0.2);
        border-bottom: 1px solid #49f0fd;
        font-weight: bold;
        text-align: center;
    }

    .list-content {
        max-height: 400px;
        overflow-y: auto;

        .personnel-item {
            padding: 8px 10px;
            cursor: pointer;
            border-bottom: 1px solid rgba(73, 240, 253, 0.1);

            &:last-child {
                border-bottom: none;
            }

            &.active {

                ::v-deep .el-checkbox,
                ::v-deep .el-checkbox__label {
                    background: rgba(73, 240, 253, 0.2);
                }
            }

            .personnel-checkbox {
                width: 100%;

                .item-info {
                    margin-left: 20px;

                    .name {
                        font-weight: bold;
                        margin-bottom: 4px;
                    }

                    .distance,
                    .duration {
                        font-size: 12px;
                        color: #ccc;
                    }
                }
            }
        }
    }

    .no-data {
        padding: 10px 0;
        text-align: center;
        color: #ccc;
    }
}

// 距离标注样式
.point-distance {
    font-size: 14px;
    color: #fff;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: rgba(7, 17, 80, 0.7);
    box-shadow: inset 0px 1px 12px 0px rgba(26, 71, 164, 0.65);
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #49f0fd;
    padding: 0 5px;
}

.point-distance-active {
    height: 22px;
    line-height: 22px;
    padding: 0 5px;
    text-align: center;
    font-size: 14px;
    color: #10163a;
    background: linear-gradient(90deg, #ff8b00 0%, rgba(255, 214, 0, 0.94) 100%);
    border-radius: 2px 2px 2px 2px;
}

// 滚动条
::v-deep .list-content::-webkit-scrollbar {
    width: 4px;
}

::v-deep .list-content::-webkit-scrollbar-track {
    background: rgba(7, 17, 80, 0.5);
}

::v-deep .list-content::-webkit-scrollbar-thumb {
    background: #49f0fd;
    border-radius: 2px;
}
</style>
